/* STENCIL IMPORTS */
import { h } from "@stencil/core";
/* OTHER LIBRARIES IMPORTS */
/* CUSTOM IMPORTS */
import { GxOption } from "./types";

export const renderComboItems = (
  gxOptions: Array<GxOption>
): HTMLGxgComboBoxItemElement[] => {
  const comboItemsArray: HTMLGxgComboBoxItemElement[] = [];
  gxOptions.forEach((gxOption: GxOption) => {
    const iconName = gxOption.iconName || gxOption.icon;
    const value = gxOption.value || gxOption.id;
    comboItemsArray.push(
      <gxg-combo-box-item value={value} icon={iconName}>
        {gxOption.label || gxOption.name || gxOption.value || gxOption.id}
      </gxg-combo-box-item>
    );
  });
  return comboItemsArray;
};
